import React from "react";
import AllDeliveryReturns from "./DeliveryReturnsModule/AllDeliveryReturns";

const DeliveryReturns = () => {
  return (
    <div>
      <AllDeliveryReturns />
    </div>
  );
};

export default DeliveryReturns;
